import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../MetaPixel';
interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  onClick?: () => void;
  href?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  onClick,
  href,
  fullWidth = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold uppercase tracking-wide transition-all duration-200 rounded-sm py-4 px-8 text-lg cursor-pointer';
  const variants = {
    primary: 'bg-brand-red hover:bg-brand-redHover text-white shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)]',
    secondary: 'bg-brand-gold hover:bg-brand-goldLight text-black font-extrabold',
    outline: 'border-2 border-white/20 hover:border-white/50 text-white bg-transparent'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const CART_LINK = 'https://guiaspracticas.store/cart/51259935031586:1?checkout';
  const isCartLink = href === CART_LINK;
  const isScrollLink = !href;
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) onClick();
    if (isScrollLink) {
      e.preventDefault();
      const target = document.getElementById('descargar');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      return;
    }
    if (isCartLink) {
      trackAddToCart();
    }
  };
  return <motion.a href={href || '#descargar'} target={isScrollLink ? undefined : '_blank'} rel={isScrollLink ? undefined : 'noopener noreferrer'} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-195">
      {children}
    </motion.a>;
}